package com.example.mystybag.common.ui.components.custom

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ColorFilter
import dev.icerock.moko.resources.ImageResource
import dev.icerock.moko.resources.compose.painterResource
import com.example.mystybag.common.extensions.AsyncImage
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.rippleClick
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p42
import com.example.mystybag.core.views.AppTheme

@Composable
fun ChooseItemRowView(
    modifier        : Modifier                      = Modifier,
    iconId          : ImageResource?                = null,
    link            : String?                       = null,
    text            : String?                       = "",
    onClick         : () -> Unit                    = {},
    trailingIcon    : @Composable (() -> Unit)?     = null
) {
    Row (
        modifier            = modifier.rippleClick(action = onClick),
        verticalAlignment   = Alignment.CenterVertically
    ) {
        iconId?.let {
            Image(
                painter             = painterResource(it),
                modifier            = Modifier
                    .size(p42)
                    .padding(end = p16),
                colorFilter = ColorFilter.tint(AppTheme.current.colors.onSurface)
            )
        } ?: run {
            link?.also {
                AsyncImage(
                    link     = it,
                    modifier = Modifier
                        .size(p42)
                        .padding(end = p12)
                )
            }
        }

        Texts.BodyLarge(
            text        = text ?: "",
            modifier    = Modifier.weight(1f)
        )

        trailingIcon?.invoke()
    }
}

/*@Preview
@Composable
fun ChooseItemRowViewPreview() {
    AppTheme.setup(false)
    AppThemeView {
        Row(modifier = Modifier.background(AppTheme.current.colors.surface).padding(p3XS)) {
            ChooseItemRowView(iconId = SRC.images.country_image_ita, text = "Italy")
        }
    }
}*/